<!--
정상(발송완료) 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <!-- stepper -->
            <div class="uk-modal-header">
                <div class="stepper">
                    <div
                        class="step"
                        :class="step1Class"
                    >
                        <div class="circle">1</div>
                        <div class="label">발송대기</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step2Class"
                    >
                        <div class="circle">2</div>
                        <div class="label">패킹대기</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step3Class"
                    >
                        <div class="circle">3</div>
                        <div class="label">보관장소</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step4Class"
                    >
                        <div class="circle">4</div>
                        <div class="label">라벨출력</div>
                    </div>
                </div>
            </div>


            <div class="uk-modal-body uk-padding-small">
                <!-- 발송대기 -->
                <div v-show="currStep === 1">
                    <div class="uk-text-large uk-text-center">
                        AJAX 통신중...
                    </div>
                </div>

                <!-- 패킹대기 안내 -->
                <div v-if="currStep === 2">
                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        모든 상품이 준비되었습니다. 패킹하세요
                    </div>

                    <div class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2 uk-modal-close"
                        >
                            <i class="material-icons">tab</i>
                            패킹작업
                        </button>
                    </div>
                </div>

                <!-- 보관장소 -->
                <div v-if="currStep === 3">

                    <app-input-ex
                        class="uk-margin-bottom"
                        type="text"
                        input-size="large"

                        name="memo"
                        v-model="storage"
                        label="보관장소"

                        required-layout="label-left"

                        placeholder="보관장소를 입력하세요"
                    > </app-input-ex>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2"
                            v-on:click="saveStorage"
                        >
                            <span uk-icon="icon: check"></span>
                            보관장소 입력
                        </button>
                    </div>
                </div>

                <!-- 라벨출력 -->
                <div v-if="currStep === 4">
                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        합배송 상품이 아직 준비되지 않아, [발송대기] 처리되었습니다<br />
                        보관라벨 출력 후 상품을 보관하세요
                    </div>

                    <div class="uk-text-large4 uk-text-center uk-margin-bottom uk-text-primary">
                        {{ storage }}
                    </div>

                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2"
                            onclick="$.app.print.store_label(arguments);"
                            :data-prod-id="shipProd.id"
                            title="현재 상품의 보관라벨을 출력합니다"
                        >
                            <i class="material-icons" style="font-size: 48px; vertical-align: middle">print</i>
                            <span class="text">PRINT STORE-LABEL (보관라벨)</span>
                        </button>
                    </div>

                    <hr />

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large2 uk-margin-right"
                            v-on:click="currStep = 3"
                        >
                            <i class="material-icons">keyboard_arrow_left</i>
                            뒤로 (보관장소 수정)
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2 uk-modal-close"
                        >
                            <i class="material-icons">check</i>
                            완료
                        </button>
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 발송요청
            req: Object,

            // 목록 url
            listUrl: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                /**
                 * (object) 완료처리 후 서버로부터 전달받은 배송상품 정보
                 */
                shipProd: null,

                /**
                 * 보관장소
                 */
                storage: null,

                /**
                 * (int) 진행단계
                 *       1~4
                 **/
                currStep: 1,

                // (bool) 모달창 종료이벤트 등록된적있는지 플래그값, 창 여러번 켜고 닫을때, 이벤트 한번만 등록되기 위함
                hasModalCloseEvent: false,

                /**
                 * (string) 정상처리의 결과
                 *      - 'out-ready'
                 *      - 'pack-ready'
                 **/
                resultState: null,

                /**
                 * (int) 하우스ID
                 **/
                houseId: null,

            };
        },
        computed: {
            // 스텝1 클래스계산
            step1Class: function () {
                let step = 1;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝2 클래스계산
            step2Class: function () {
                let step = 2;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝3 클래스계산
            step3Class: function () {
                let step = 3;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝4 클래스계산
            step4Class: function () {
                let step = 4;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
        },
        methods: {

            /**
             * 폼
             */
            form() {

                // 폼 띄우기
                UIkit.modal(this.$el).show();

                // 모달창 종료이벤트
                if (! this.hasModalCloseEvent) {
                    UIkit.util.on(this.$el, 'beforehide', () => {
                        //console.log('before');
                        this.done();

                    });

                    this.hasModalCloseEvent = true;
                }

                // submit
                this.submit();
            },




            /**
             * submit
             */
            submit() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/region-out-requests/' + this.req.id + '/done',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.shipProd = response.ship_prod;
                    if (! this.shipProd) {
                        // 배송상품 없이, 요청메모로만 발송완료처리 된 경우
                        alert('발송작업이 완료되었습니다. 다시 발송작업 목록으로 이동합니다');
                        this.done();
                        return;
                    }

                    // 배송상품 있음.
                    this.storage = this.shipProd.storage;
                    this.resultState = this.shipProd.state;
                    this.houseId = this.shipProd.lock_pack_ready;


                    // 패킹대기 구분
                    if (this.resultState == 62) {
                        this.currStep = 2;
                        // 패킹대기화면 안보여주고 바로 패킹페이지로 이동
                        this.done();
                        return;
                    }



                    // 보관장소가 발급되었으면, 입력단계 건너뜀
                    if (this.storage) {
                        this.currStep = 4;
                    } else {
                        this.currStep = 3;
                    }

                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },

            /**
             * 보관장소저장 완료처리
             */
            saveStorage() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.shipProd.id + '/storage',
                        data: {
                            '_token': this.csrfToken,
                            'storage': this.storage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.currStep = 4;
                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },



            /**
             * 작업완료 (창 닫기했을때 실행되는 액션)
             */
            done() {
                if (this.resultState === 62) {
                    // 패킹페이지 이동
                    $.app.move('/houses/'+this.houseId+'/pack?from=out-requests&list_url=' + encodeURIComponent(this.listUrl));
                    return;
                }

                // 작업 목록으로
                // 리스트로 이동
                if (this.listUrl) {
                    $.app.move(this.listUrl);
                } else {
                    $.app.move('/regions/'+this.req.region_id+'/out-requests');
                }

            },
        },
    }
</script>

<style lang="scss" scoped>
    /*
    stepper css
    https://codepen.io/shanejdonnelly/pen/wJqgQR?page=3
    */
    .stepper{
        clear: left;
        float: left;
        font-size: 1.5rem;
        margin: 10px;
    }

    .step{
        float: left;
    //    font-size: 15px;
        margin: 0 12px;
    }

    .divider{ border-bottom: 1px solid #cfcfcf; float: left; height: 12px; margin: 0 12px; width: 45px; }

    .circle{
        background: #cfcfcf;
        border-radius: 50%;
        color: #ffffff;
        float: left;
        height: 30px;
        line-height: 30px;
        text-align: center;
        width: 30px;
    }

    .label{ color: #cfcfcf; float: left; line-height: 24px; margin-left: 8px; }

    .active{
        .circle{ background: #0f7ae5; }
        .label{ color: #0f7ae5; font-weight: 400; }
    }

    .complete{
        .circle{
            background: #666;
        }
        .label{
            color: #666;
            text-decoration-line: line-through;
        }
    }
</style>